// Flat properties has to be customized based on database records. eg. If you have area property named 'powierzchnia' in the database, just write area: 'powierzchnia'.
const flatProperties = {
  building: 'building',
  area: 'area_flat',
  id: 'investments_number',
  realID: 'investments_number',
  price: 'price',
  floor: 'investments_floor',
  rooms: 'investments_rooms',
  balcony: 'balcony',
  status: 'status_id',
  twoDURL: '',
  threeDURL: 'png',
  pdfURL: 'pdf',
  status_available: 1,
  status_reserved: 2,
  status_sold: 3,
  local: 'lokal_str',
  type: 'investments_type',
  // Amenities are listed below, each also flat has it's own array of amenities.
  amenities: ['balkon'],
};

export default flatProperties;
